var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { AbstractRadio } from 'Permafrost/index';
import { StyledRadioGroup } from './RadioButtons.styles';
/**
 * Renders a group of radio buttons.
 *
 * A group label must be included: either pass a string or markup into the
 * `label` prop, or include an `aria-label` or `aria-labelledby` attribute.
 */
export function RadioGroup(props) {
    const { children } = props, restOfProps = __rest(props, ["children"]);
    return (React.createElement(StyledRadioGroup, Object.assign({}, restOfProps, { "data-cy": props['data-cy'] }), children));
}
/**
 * A single radio button and its label.
 */
export function Radio(props) {
    const { children } = props, restOfProps = __rest(props, ["children"]);
    return (React.createElement(AbstractRadio, Object.assign({}, restOfProps),
        React.createElement("svg", { viewBox: "0 0 20 20", "aria-hidden": "true", focusable: "false", overflow: "visible" },
            React.createElement("circle", { cx: 10, cy: 10, r: 9, fill: "none", stroke: "currentColor", className: "radioCircle" }),
            React.createElement("circle", { cx: 10, cy: 10, r: 5, fill: "currentColor", stroke: "none", className: "radioDot" }),
            React.createElement("circle", { cx: 10, cy: 10, r: 12, fill: "none", className: "focusRing" })),
        children));
}
//# sourceMappingURL=RadioButtons.js.map